var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaticShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_37019)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2963_37019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z",
    fill: "#FF3333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z",
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 68C27.79 68 26 66.21 26 64C26 61.79 27.79 60 30 60C32.21 60 34 61.79 34 64C34 66.21 32.21 68 30 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 66C30.2663 66.006 30.5311 65.9588 30.779 65.861C31.0268 65.7633 31.2526 65.617 31.4431 65.4308C31.6336 65.2446 31.785 65.0222 31.8884 64.7766C31.9918 64.5311 32.0451 64.2674 32.0452 64.001C32.0452 63.7346 31.9921 63.4708 31.8888 63.2253C31.7855 62.9797 31.6343 62.7572 31.4438 62.5709C31.2534 62.3846 31.0277 62.2382 30.7799 62.1403C30.5321 62.0425 30.2673 61.9951 30.0009 62.001C29.4784 62.0125 28.9811 62.2282 28.6156 62.6018C28.25 62.9754 28.0453 63.4773 28.0452 64C28.045 64.5227 28.2495 65.0246 28.6149 65.3984C28.9802 65.7722 29.4774 65.9882 30 66Z",
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2963_37019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 20C34 18.9391 33.5786 17.9217 32.8284 17.1716C32.0783 16.4214 31.0609 16 30 16C28.9391 16 27.9217 16.4214 27.1716 17.1716C26.4214 17.9217 26 18.9391 26 20V21H27V20C27 18.895 28 17.4 30 17.4C32 17.4 33 18.895 33 20V21H34V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9979 22.802C20.9989 22.519 20.9999 22.378 21.0549 22.272C21.1027 22.1781 21.179 22.1018 21.2729 22.054C21.3799 22 21.5199 22 21.7999 22H38.1999C38.4799 22 38.6199 22 38.7269 22.054C38.8209 22.102 38.8969 22.178 38.9449 22.272C38.9999 22.378 39.0009 22.519 39.0019 22.802C39.0419 31.052 39.6799 36.345 39.9509 38.229C39.9909 38.506 40.0109 38.644 39.9739 38.756C39.9409 38.8545 39.878 38.9401 39.7939 39.001C39.6999 39.071 39.5669 39.094 39.3019 39.14C37.7039 39.415 33.8519 40 29.9999 40C26.1479 40 22.2959 39.415 20.6979 39.14C20.4329 39.094 20.2999 39.071 20.2049 39.001C20.1212 38.9399 20.0586 38.8543 20.0259 38.756C19.9889 38.644 20.0089 38.506 20.0489 38.229C20.3199 36.345 20.9589 31.052 20.9989 22.802H20.9979ZM26.9999 24.5C26.9999 24.3674 26.9472 24.2402 26.8534 24.1464C26.7597 24.0527 26.6325 24 26.4999 24H25.4999C25.3673 24 25.2401 24.0527 25.1463 24.1464C25.0526 24.2402 24.9999 24.3674 24.9999 24.5C24.9999 24.6326 25.0526 24.7598 25.1463 24.8536C25.2401 24.9473 25.3673 25 25.4999 25H25.9999V25.5C25.9999 26.5609 26.4213 27.5783 27.1715 28.3284C27.9216 29.0786 28.939 29.5 29.9999 29.5C31.0607 29.5 32.0782 29.0786 32.8283 28.3284C33.5785 27.5783 33.9999 26.5609 33.9999 25.5V25H34.4999C34.6325 25 34.7597 24.9473 34.8534 24.8536C34.9472 24.7598 34.9999 24.6326 34.9999 24.5C34.9999 24.3674 34.9472 24.2402 34.8534 24.1464C34.7597 24.0527 34.6325 24 34.4999 24H33.4999C33.3673 24 33.2401 24.0527 33.1463 24.1464C33.0526 24.2402 32.9999 24.3674 32.9999 24.5V25C32.9999 26.38 31.9999 28 29.9999 28C27.9999 28 26.9999 26.38 26.9999 25V24.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2963_37019",
    x: 1,
    y: -1,
    width: 58,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_2963_37019"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_37019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 68,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2963_37019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticShop);
export default __webpack_public_path__ + "static/media/staticShop.996c313bb0231a3def03413e23f1bd11.svg";
export { ForwardRef as ReactComponent };